module.exports = __webpack_public_path__ + "img/wangnan.53d26b5d.png";